import "css/shippingResponsive.css";
import React, {  useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux"; 
import { useTranslation } from "react-i18next";
import { ENDPOINT, LIMIT_PAGE } from "constants/variables";
import Box from '@mui/material/Box'; 
import CircularProgress from '@mui/material/CircularProgress'; 
import Container from '@mui/material/Container';
import SwipeableDrawer from '@mui/material/SwipeableDrawer'; 
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded'; 
import "css/generalSettings.css";
import "css/customDialog.css";
import { warningErrorAction } from "actions/ErrorActions";
import { helpHttp } from "service/HelpHttp";
import { setLoading } from 'reducers/loadingSlice';
import { LoadingNews } from "components/utils/LoadingNews";
import TableSortingArticle from 'pages/shipping/editOrNewShipping/SortingTablesShippingArticles'; 
import PropTypes from 'prop-types';
import { articleMatchesSearch } from './utils/articleSearchNormalization';

const initialFiltersArticle= {
  "excludedDepartmentCode":"000001",
  "idFrom":"",
  "idTo":"",
  "owncodeFrom":"",
  "owncodeTo":"",
  "codeanFrom":"",
  "codeanTo":"",
  "barcodeFrom":"",
  "barcodeTo":"",
  "codeLerFrom":"",
  "codeLerTo":"",
  "nameesFrom":"",
  "nameesTo":"",
  "nameenFrom":"",
  "nameenTo":""
}; 
 
const initialStateArticle = [{
  "article_id":0,
  "article_owncode": "",
  "article_codean": "",
  "article_barcode": "", 
  "article_codeler": "",
  "article_namees": "",
  "article_nameen": "", 
  "article_tax":0,
  "article_taxincluded":false,
  "articlestoretypesofprices":[]
}];

const ShippingSearchArticles = ({ showModalSearchArticles, setShowModalSearchArticles,formShipping,setFormShipping}) => {
  const {t,i18n} = useTranslation(['listDataPurchases']);
  const [departments, setDepartments] = useState([]);
  const token = useSelector((state) => state.loginUser.token);  
  const [dataArticle, setDataArticle] = useState(initialStateArticle);
  const [isLoadingErrorArticle, setIsLoadingErrorArticle] = useState(false);
  const [isLoadingArticle, setIsLoadingArticle] = useState(false);  
  const [inputTextArticle, setInputTextArticle] = useState("");
  const [applyFiltersArticle, setApplyFiltersArticle]= useState(initialFiltersArticle);
  const [filtersArticle, setFiltersArticle]= useState(initialFiltersArticle);
  const [openEditFilterArticle,setOpenEditFilterArticle]= useState(false);
  const [errorsFiltersArticle, setErrorsFiltersArticle] = useState({});
  const [numTotRegFilter,setNumTotRegFilter]= useState(0);
  const [numTotRegArticle,setNumTotRegArticle]= useState(0);
  const [activeOffsetArticle, setActiveOffsetArticle]= useState(false);
  const [currencyOffsetArticle, setCurrencyOffsetArticle] = useState(0);
  const [rangeOffsetArticle, setRangeOffsetArticle] = useState([{}]);
  const hasCodeFilters = ['owncodeFrom', 'owncodeTo', 'codeanFrom', 'codeanTo',
    'barcodeFrom', 'barcodeTo', 'codeLerFrom', 'codeLerTo']
    .some(key => Boolean(applyFiltersArticle[key])); 
  const dispatch = useDispatch(); 
   
  useEffect(() => {
    if (!showModalSearchArticles) return;
    let active = true;
    helpHttp().get(ENDPOINT, 'department/simpledepartmentsbynamees', token)
      .then(data => {
        if (!active) return;
        if (Array.isArray(data)) setDepartments(data);
        else dispatch(warningErrorAction(t('Text_ConnectionFailied')));
      })
      .catch(() => { if (active) dispatch(warningErrorAction(t('Text_ConnectionFailied'))); });
    return () => { active = false; };
  }, [showModalSearchArticles, token, dispatch, t]);

  const changeExcludedDepartment = (event) => {
    const excludedDepartmentCode = event.target.value;
    setFiltersArticle(previous => ({ ...previous, excludedDepartmentCode }));
  };

  const handleCloseDataEditArticle = () => {
    setDataArticle(initialStateArticle);
    setIsLoadingErrorArticle(false);
    dispatch(setLoading(false));
    setInputTextArticle("");
    setApplyFiltersArticle(initialFiltersArticle);
    setFiltersArticle(initialFiltersArticle);
    setOpenEditFilterArticle(false);
    setErrorsFiltersArticle({});
    setNumTotRegFilter(0);
    setNumTotRegArticle(0);
    setActiveOffsetArticle(false);
    setCurrencyOffsetArticle(0);
    setRangeOffsetArticle([{}]); 
    setShowModalSearchArticles(false)
	};

  const toggleDrawerSearchArticles  = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown') {
      handleCloseDataEditArticle();
    }
  };

  let inputHandlerArticle = (e) => {
    var lowerCase = e.target.value.toLowerCase();
    setInputTextArticle(lowerCase);
  };

  const openEditFiltersArticle = () => {
    setFiltersArticle(applyFiltersArticle);
    setOpenEditFilterArticle(!openEditFilterArticle);
  };

  const toggleDrawerFilterEditArticle = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown') {
      event.preventDefault();
      handleCloseDataEditArticle();
    }
  };

  const handleCancelFiltersArticle = () => {
    setErrorsFiltersArticle({});
    setFiltersArticle(initialFiltersArticle);
    setOpenEditFilterArticle(!openEditFilterArticle);
  };

  const handleChangeFilterEditArticle = (e) => {
    const { name, value } = e.target;
    setFiltersArticle(filtersArticle => ({
      ...filtersArticle,
      [name]: value
    }));
  };

  const handleBlurFilterEditArticle = (e) => {
    setErrorsFiltersArticle(validateFormFilterArticle());
    handleChangeFilterEditArticle(e);
  };
 
  const handleSubmitFilterEditArticle = () => {
    setErrorsFiltersArticle(validateFormFilterArticle());
    if (Object.keys(errorsFiltersArticle).length === 0) {
      setCurrencyOffsetArticle(0);
      setApplyFiltersArticle(filtersArticle);
      setFiltersArticle(initialFiltersArticle);
      setErrorsFiltersArticle({});
      setOpenEditFilterArticle(false);
    }  else{
      dispatch(warningErrorAction(t('Text_Error_Filter')));
    }
  }
  const handleDeleteFiltersArticle = () => {
    setErrorsFiltersArticle({});
    setFiltersArticle(initialFiltersArticle);
    setApplyFiltersArticle(initialFiltersArticle);
    setOpenEditFilterArticle(!openEditFilterArticle);
  };

  const validateFormFilterArticle = () => {
    let errorsFiltersArticle = {};
    let regexNumber = /^[0-9]+$/;
    let regexInvalidCharacters = /[\\!\\$\\%\\&\\|\\<\\>\\?\\{\\}\\~\\"\\']+/;
    
    if (filtersArticle.idFrom!=="" & !regexNumber.test(filtersArticle.idFrom)) {
      errorsFiltersArticle.idFrom = 'Text_TextNoNumber';
    }
    if (filtersArticle.idTo!=="" & !regexNumber.test(filtersArticle.idTo)) {
      errorsFiltersArticle.idTo = 'Text_TextNoNumber';
    }
    if (filtersArticle.idFrom!=="" & !errorsFiltersArticle.idFrom!==undefined){
      if (filtersArticle.idTo!=="" & !errorsFiltersArticle.idTo!==undefined){
        if (parseInt(filtersArticle.idTo)<parseInt(filtersArticle.idFrom)){
          errorsFiltersArticle.idTo = 'Text_TextGreater_Id';
        }
      }
    }
    if (regexInvalidCharacters.test(filtersArticle.nameesFrom)) {
      errorsFiltersArticle.nameesFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersArticle.nameesTo)) {
      errorsFiltersArticle.nameesTo = 'Text_TextNoValid';
    } 
     if (regexInvalidCharacters.test(filtersArticle.nameesFrom)) {
      errorsFiltersArticle.nameesFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersArticle.nameesTo)) {
      errorsFiltersArticle.nameesTo = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersArticle.nameenFrom)) {
      errorsFiltersArticle.nameenFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersArticle.nameenTo)) {
      errorsFiltersArticle.nameenTo = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersArticle.codeLerFrom)) {
      errorsFiltersArticle.codeLerFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersArticle.codeLerTo)) {
      errorsFiltersArticle.codeLerTo = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(filtersArticle.owncodeFrom)) {
      errorsFiltersArticle.owncodeFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersArticle.owncodeTo)) {
      errorsFiltersArticle.owncodeTo = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(filtersArticle.codeanFrom)) {
      errorsFiltersArticle.codeanFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersArticle.codeanTo)) {
      errorsFiltersArticle.codeanTo = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(filtersArticle.barcodeFrom)) {
      errorsFiltersArticle.barcodeFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersArticle.barcodeTo)) {
      errorsFiltersArticle.barcodeTo = 'Text_TextNoValid';
    } 

    if (filtersArticle.nameesTo!=="" & filtersArticle.nameesTo<filtersArticle.nameesFrom){
      errorsFiltersArticle.nameesTo = 'Text_TextGreater_Namees';
    }
    if (filtersArticle.nameenTo!=="" & filtersArticle.nameenTo<filtersArticle.nameenFrom){
      errorsFiltersArticle.nameenTo = 'Text_TextGreater_Nameen';
    }
    if (filtersArticle.owncodeTo!=="" & filtersArticle.owncodeTo<filtersArticle.owncodeFrom){
      errorsFiltersArticle.owncodeTo = 'Text_TextGreater_Article_OwnCode';
    }
    if (filtersArticle.codeanTo!=="" & filtersArticle.codeanTo<filtersArticle.codeanFrom){
      errorsFiltersArticle.codeanTo = 'Text_TextGreater_Article_Codean';
    }
    if (filtersArticle.barcodeTo!=="" & filtersArticle.barcodeTo<filtersArticle.barcodeFrom){
      errorsFiltersArticle.barcodeTo = 'Text_TextGreater_Article_BarCode';
    }
    if (filtersArticle.codeLerTo!=="" & filtersArticle.codeLerTo<filtersArticle.codeLerFrom){
      errorsFiltersArticle.codeLerTo = 'Text_TextGreater_ArticleLER';
    }
    return errorsFiltersArticle;
  }  

  const filteredDataArticle = dataArticle.filter((el) => {
      const searchableArticle = [
        String(el.article_owncode || ''),
        String(el.article_codean || ''),
        String(el.article_barcode || ''),
        String(el.article_codeler || ''),
        String(el.article_namees || ''),
        String(el.article_nameen || ''),
      ].join(' ');
      return articleMatchesSearch(searchableArticle, inputTextArticle);
  })

  useEffect(() => {
    let isMounted = true;

    const fetchnumTotRegArticle = async () => {
      dispatch(setLoading(true));
      try { 
        const getData = await helpHttp().post(ENDPOINT, `shipping/getcountfilterarticles`, token, { ...initialFiltersArticle, excludedDepartmentCode: applyFiltersArticle.excludedDepartmentCode });
        if (getData.err) {
          setDataArticle(initialStateArticle);
          dispatch(setLoading(false));
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (isMounted) {
          setNumTotRegArticle(getData);
          dispatch(setLoading(false));
        }
      } catch (error) {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      } 
    };

    const fetchnumTotRegFilter = async () => {
      dispatch(setLoading(true));
      try {
        const getData = await helpHttp().post(ENDPOINT, `shipping/getcountfilterarticles`, token, applyFiltersArticle);
        if (getData.err || getData.message === "Load failed") {
          setDataArticle(initialStateArticle);
          dispatch(setLoading(false));
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (isMounted) {
          setNumTotRegFilter(getData);
          dispatch(setLoading(false));
        }
      } catch (error) {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      } 
    };

    const fetchDataArticle = async () => {
      dispatch(setLoading(true));
      try {
        const getData = await helpHttp().get3(ENDPOINT,`shipping/getarticles`,token,currencyOffsetArticle,LIMIT_PAGE,applyFiltersArticle);
        if (getData.err || getData.message === "Load failed") {
          setDataArticle(initialStateArticle);
          dispatch(setLoading(false));
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (isMounted) {
          setDataArticle(getData);
          dispatch(setLoading(false));
        }
      } catch (error) {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }  
    };
    
    if (showModalSearchArticles){
      fetchnumTotRegArticle();
      fetchnumTotRegFilter();
      fetchDataArticle(); 
    }
    return () => { isMounted = false };
  }, [t,i18n,token,dispatch,applyFiltersArticle,currencyOffsetArticle,setIsLoadingArticle,showModalSearchArticles]);

  return(
    <>
      {showModalSearchArticles && 
        <div>
          <SwipeableDrawer PaperProps={{ className: "shipping-search-panel shipping-article-search-panel shipping-lookup-panel" }}
            anchor='right'
            open={true}
            onClose={toggleDrawerSearchArticles(false)}
            onOpen={toggleDrawerSearchArticles(true)}>
            <Container maxWidth={false}>
              <Box sx={{ bgcolor: '#ffffff', width: '100%', minWidth: 0, maxWidth: '100%'}}>
                <br/>
                <div className="formdi-pending-header2"> 
                  <h1 className="formdi-pending-title">
                    {isLoadingErrorArticle?<i className="fas fa-solid fa-exclamation fa-2x text-danger"></i>:isLoadingArticle?<CircularProgress color={"primary"}/>:<i className="fas fa-address-card text-warning"></i>} {t('Text_ARTICLEs_Search')}
                  </h1>
                  <div>
                    <button type="button" className="formdi-pending-btn formdi-pending-btn--primary" onClick={handleCloseDataEditArticle}>{t('Button_Back')}</button><> </>
                  </div> 
                </div>  
                <br/>  
                <div className="formdi-pending-search shipping-article-search">
                  <TextField
                    id="shipping-article-search"
              autoComplete="off"
                    variant="outlined"
                    value={inputTextArticle}
                    inputProps={{ style: {fontSize: '18px'} }}
                    InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                    placeholder={t('Text_Article_Search')} 
                    onChange={inputHandlerArticle}
                    fullWidth
                    label={t('Text_Article_Search')}>
                  </TextField>
                </div>
                <br/>
                <div className="formdi-pending-filters shipping-article-filter-bar">
                  <h1 className="formdi-pending-filter-title">{t('Text_Filter')}</h1>
 
                    <div className="formdi-pending-filters-row">
                      <button type="button" className={`formdi-pending-chip ${hasCodeFilters ? "formdi-pending-chip--active" : ""}`} onClick={openEditFiltersArticle}>
                        <span className={`formdi-pending-dot ${hasCodeFilters ? "formdi-pending-dot--on" : ""}`} />
                        {t('Text_ArticleFilterCodes')}
                      </button>
                      <button type="button" className={`formdi-pending-chip ${(applyFiltersArticle.nameesFrom!=="" || applyFiltersArticle.nameesTo!=="" || applyFiltersArticle.nameenFrom!=="" || applyFiltersArticle.nameenTo!=="")? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersArticle} >
                        <span className={`formdi-pending-dot ${(applyFiltersArticle.nameesFrom!=="" || applyFiltersArticle.nameesTo!=="" || applyFiltersArticle.nameenFrom!=="" || applyFiltersArticle.nameenTo!=="")? "formdi-pending-dot--on": ""}`}/>
                        {t('Text_ARTICLE_Name').toUpperCase()}
                      </button> 
                  </div>
                </div> 
                <br/> 
                {!isLoadingArticle ?
                  <>
                    <div className="formdi-pending-card-flat">
                      <div className="formdi-pending-card-content">
                         <TableSortingArticle
                          dataArticle={filteredDataArticle}
                          numTotRegFilter={ numTotRegFilter}
                          titleTable={t('Text_ARTICLE_Table')}
                          numTotRegArticle={numTotRegArticle}
                          activeOffsetArticle={activeOffsetArticle}
                          rangeOffsetArticle={rangeOffsetArticle}
                          currencyOffsetArticle={currencyOffsetArticle}
                          setCurrencyOffsetArticle={setCurrencyOffsetArticle} 
                          formShipping={formShipping}                                  
                          setFormShipping={setFormShipping}
                          handleCloseDataEditArticle={handleCloseDataEditArticle}
                        >
                        </TableSortingArticle>
                      </div>             
                    </div>
                    {openEditFilterArticle &&
                      <div>
                      <SwipeableDrawer PaperProps={{ className: "shipping-search-panel shipping-article-search-panel shipping-lookup-panel" }}
            anchor='right'
                        open={true}
                        onClose={toggleDrawerFilterEditArticle(false)}
                        onOpen={toggleDrawerFilterEditArticle(true)}>
                        <Container maxWidth={false}>
                          <Box sx={{ bgcolor: '#ffffff', minHeight: '100vh', width: '100%', maxWidth: '100%' }}>
                            <br/>
                              <div id="myDIV">
                                <h1 className="h1NewStyle px-4 mb-2">{t('Text_Filter')}</h1>
                              </div>
                              <hr className="sidebar-divider d-none d-md-block"/>
                              <form autoComplete="off" className="newfilterformstore shipping-article-filters" onSubmit={handleCancelFiltersArticle}>  
                                <div className="form-floating mb-3 px-4 primary">
                                    <div className="form-group">
                                    <TextField autoComplete="off"
                                      id="owncodeFrom" 
                                      name="owncodeFrom"
                                      value={filtersArticle.owncodeFrom}
                                      inputProps={{ style: {width: 350,  fontSize: '18px', }, maxLength: 10 }}
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                      label={errorsFiltersArticle.owncodeFrom!=null?t(errorsFiltersArticle.owncodeFrom):t('Text_Filter_OwnCodeArticle_From')}
                                      placeholder={t('PlaceHolder_Filter_OwnCodeArticle_From')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditArticle}
                                      onChange={handleChangeFilterEditArticle}/> 
                                    
                                    <TextField autoComplete="off"
                                    
                                      id="owncodeTo" 
                                      name="owncodeTo"
                                      value={filtersArticle.owncodeTo}
                                      inputProps={{ style: {width: 350,  fontSize: '18px', }, maxLength: 10 }}
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                      label={errorsFiltersArticle.owncodeTo!=null?t(errorsFiltersArticle.owncodeTo):t('Text_Filter_OwnCodeArticle_To')}
                                      placeholder={t('PlaceHolder_Filter_OwnCodeArticle_To')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditArticle}
                                      onChange={handleChangeFilterEditArticle}/>
                                  </div>
                                  <div className="form-group">
                                    <TextField autoComplete="off"
                                      id="codeanFrom" 
                                      name="codeanFrom"
                                      value={filtersArticle.codeanFrom}
                                      inputProps={{ style: {width: 350,  fontSize: '18px', }, maxLength: 10 }}
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                      label={errorsFiltersArticle.codeanFrom!=null?t(errorsFiltersArticle.codeanFrom):t('Text_Filter_CodeEanArticle_From')}
                                      placeholder={t('PlaceHolder_Filter_CodeEanArticle_From')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditArticle}
                                      onChange={handleChangeFilterEditArticle}/> 
                                    
                                    <TextField autoComplete="off"
                                    
                                      id="codeanTo" 
                                      name="codeanTo"
                                      value={filtersArticle.codeanTo}
                                      inputProps={{ style: {width: 350,  fontSize: '18px', }, maxLength: 10 }}
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                      label={errorsFiltersArticle.codeanTo!=null?t(errorsFiltersArticle.codeanTo):t('Text_Filter_CodeEanArticle_To')}
                                      placeholder={t('PlaceHolder_Filter_CodeEanArticle_To')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditArticle}
                                      onChange={handleChangeFilterEditArticle}/>
                                  </div>
                                  <div className="form-group">
                                    <TextField autoComplete="off"
                                      id="barcodeFrom" 
                                      name="barcodeFrom"
                                      value={filtersArticle.barcodeFrom}
                                      inputProps={{ style: {width: 350,  fontSize: '18px', }, maxLength: 10 }}
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                      label={errorsFiltersArticle.barcodeFrom!=null?t(errorsFiltersArticle.barcodeFrom):t('Text_Filter_BarCodeArticle_From')}
                                      placeholder={t('PlaceHolder_Filter_BarCodeArticle_From')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditArticle}
                                      onChange={handleChangeFilterEditArticle}/> 
                                    
                                    <TextField autoComplete="off"
                                    
                                      id="barcodeTo" 
                                      name="barcodeTo"
                                      value={filtersArticle.barcodeTo}
                                      inputProps={{ style: {width: 350,  fontSize: '18px', }, maxLength: 10 }}
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                      label={errorsFiltersArticle.barcodeTo!=null?t(errorsFiltersArticle.barcodeTo):t('Text_Filter_BarCodeArticle_To')}
                                      placeholder={t('PlaceHolder_Filter_BarCodeArticle_To')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditArticle}
                                      onChange={handleChangeFilterEditArticle}/>
                                  </div>

                                   <div className="form-group">
                                    <TextField autoComplete="off"
                                      id="codeLerFrom" 
                                      name="codeLerFrom"
                                      value={filtersArticle.codeLerFrom}
                                      inputProps={{ style: {width: 350,  fontSize: '18px', }, maxLength: 10 }}
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                      label={errorsFiltersArticle.codeLerFrom!=null?t(errorsFiltersArticle.codeLerFrom):t('Text_Filter_CodeLERArticle_From')}
                                      placeholder={t('PlaceHolder_Filter_CodeLERArticle_From')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditArticle}
                                      onChange={handleChangeFilterEditArticle}/> 
                                    
                                    <TextField autoComplete="off"
                                    
                                      id="codeLerTo" 
                                      name="codeLerTo"
                                      value={filtersArticle.codeLerTo}
                                      inputProps={{ style: {width: 350,  fontSize: '18px', }, maxLength: 10 }}
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                      label={errorsFiltersArticle.codeLerTo!=null?t(errorsFiltersArticle.codeLerTo):t('Text_Filter_CodeLERArticle_To')}
                                      placeholder={t('PlaceHolder_Filter_CodeALERrticle_to')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditArticle}
                                      onChange={handleChangeFilterEditArticle}/>
                                  </div>
                                  <div className="form-group">
                                    <TextField autoComplete="off"
                                      id="nameesFrom" 
                                      name="nameesFrom"
                                      value={filtersArticle.nameesFrom}
                                      inputProps={{ style: {width: 350,  fontSize: '18px', }, maxLength: 100 }}
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                      label={errorsFiltersArticle.nameesFrom!=null?t(errorsFiltersArticle.nameesFrom):t('Text_Filter_NameEs_From')}
                                      placeholder={t('PlaceHolder_Filter_NameEs_From')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditArticle}
                                      onChange={handleChangeFilterEditArticle}/>
                                      
                                    <TextField autoComplete="off"
                                      
                                      id="nameesTo" 
                                      name="nameesTo"
                                      value={filtersArticle.nameesTo}
                                      inputProps={{ style: {width: 350,  fontSize: '18px', }, maxLength: 100 }}
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                      label={errorsFiltersArticle.nameesTo!=null?t(errorsFiltersArticle.nameesTo):t('Text_Filter_NameEs_To')}
                                      placeholder={t('PlaceHolder_Filter_NameEs_to')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditArticle}
                                      onChange={handleChangeFilterEditArticle}/>
                                  </div> 
                                  <div className="shipping-department-filter-row">
                  <TextField
                    select fullWidth
                    className="shipping-excluded-department"
                    sx={{ width: '100%', minWidth: 0, maxWidth: 'none', justifySelf: 'stretch', '& .MuiInputBase-root': { width: '100% !important', maxWidth: 'none' } }}
                    label={t('Text_ExcludeDepartment')}
                    value={filtersArticle.excludedDepartmentCode}
                    onChange={changeExcludedDepartment}
                    SelectProps={{
                      displayEmpty: true,
                      MenuProps: {
                        PaperProps: { className: 'shipping-department-menu' },
                        MenuListProps: { 'aria-label': t('Text_ExcludeDepartment') }
                      }
                    }}
                    InputLabelProps={{ shrink: true }}
                  >
                    <MenuItem value="">
                      <span className="department-name">{t('Text_ExcludeNoDepartment')}</span>
                      <CheckRoundedIcon className="department-check" />
                    </MenuItem>
                    {(!departments.some(department => department.code === '000001')
                      ? [{ id: 'default-ler', code: '000001', namees: t('Text_LerDepartment'), nameen: t('Text_LerDepartment') }, ...departments]
                      : departments).map(department => (
                      <MenuItem key={department.id} value={department.code}>
                        <span className="department-code">{department.code}</span>
                        <span className="department-name">{i18n.language.startsWith('es') ? department.namees : department.nameen}</span>
                        <CheckRoundedIcon className="department-check" />
                      </MenuItem>
                    ))}
                  </TextField>
                                  </div>
                                </div>
                                <hr className="sidebar-divider d-none d-md-block"/>
                                <div className="formdi-pending-action-group">
                                  <button className="formdi-pending-action-btn formdi-pending-action-btn--primary" type="button"  onClick={handleSubmitFilterEditArticle}>
                                    {t('Button_Apply')}
                                  </button> 
                                  <button className="formdi-pending-action-btn formdi-pending-action-btn--secondary" type="button" onClick={handleDeleteFiltersArticle}>
                                    {t('Button_Cancel_Filters')}
                                  </button>
                                </div>  
                            </form>
                          </Box>
                        </Container>
                      </SwipeableDrawer>
                    </div>
                  }   
                  {/* End Content Row */}
                  </>:
                    <LoadingNews/>
                }
              </Box>
            </Container>
          </SwipeableDrawer>
        </div>
      }  
    </>
  )
}

ShippingSearchArticles.propTypes = {
  showModalSearchArticles: PropTypes.bool.isRequired,
  setShowModalSearchArticles: PropTypes.func.isRequired,
  setFormShipping: PropTypes.func.isRequired
};

export default ShippingSearchArticles;
